import React from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, withStyles, FormControl, TextField } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import PageTitle from '../../components/PageTitle/PageTitle';
import IconButton from '@material-ui/core/IconButton';
// import CustomToolbar from "./CustomToolbar";
import * as Icons from '@material-ui/icons';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import Loader from '../../components/Loader/LoaderView';
import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';
import { clearLocalStorage } from '../../utils/common';
import CustomFooter from '../../components/Table/CustomFooter';

class LocationsManager extends React.Component {
  async componentDidMount() {
    const { offset, limit, search, sort, order, action } = this.props.locations.toJS();
    if (action) {
      await this.props.locations.getLocationList(offset, limit, search, sort, order);
      this.props.locations.setAction('action', null);
    } else {
      this.props.locations.resetData();
      await this.props.locations.getLocationList();
    }
  }

  deleteItem(id) {
    const { t } = this.props;
    Swal.fire({
      html: `<h4>${t('remove_location')}`,
      type: 'warning',
      showCancelButton: true,
      cancelButtonText: `${t('cancel')}`,
      confirmButtonText: `${t('remove')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          const result = await this.props.locations.deleteLocation(id);

          // delete location from locationPermission as well
          await this.props.user.updateLocationPermission([id]);

          if (result.statusCode === 200) {
            Swal.fire({ html: `<h4>${t('remove_success')}`, type: 'success' }).then(async (resultSuccess) => {
              if (resultSuccess.value) {
                await this.props.locations.getLocationList();
              } else {
                Swal.fire({ html: `<h4>${t('failed_to_remove')}`, type: 'error' });
              }
            });
          }
        } catch (e) {
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else if (e.statusCode === 400) {
            const msg = e.error.message || `${t('failed_to_unassign')}`;
            Swal.fire({ html: `<h4>${msg}`, type: 'error' });
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_remove')}`, type: 'error' });
          }
        }
      }
    });
  }

  unassign(id) {
    const { t } = this.props;
    Swal.fire({
      html: `<h4>${t('unassign_this_group')}`,
      type: 'warning',
      showCancelButton: true,
      cancelButtonText: `${t('cancel')}`,
      confirmButtonText: `${t('unassign')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          // get all groups before they are unassigned
          const groups = await this.props.group.getGroupByLocationId(id);

          const result = await this.props.group.unassignGroup(id);

          // delete group from groupPermission as well
          const groupIds = [];
          (groups || []).map((group) => {
            groupIds.push(group.id);
            return true;
          });
          await this.props.user.updateGroupPermission(groupIds);

          // delete subgroup from subgroupPermission as well
          for (const gid of groupIds) {
            const subgroups = await this.props.subGroup.getSubGroupByGroupID(gid);
            const subgroupIds = [];
            (subgroups || []).map((subgroup) => {
              subgroupIds.push(subgroup.id);
              return true;
            });
            await this.props.user.updateSubgroupPermission(subgroupIds);
          }

          if (result.statusCode === 200) {
            Swal.fire({ html: `<h4>${t('unassign_success')}`, type: 'success' }).then(async (resultSuccess) => {
              if (resultSuccess.value) {
                await this.props.locations.getLocationList();
              } else {
                Swal.fire({ html: `<h4>${t('failed_to_unassign')}`, type: 'error' });
              }
            });
          }
        } catch (e) {
          console.log('error', e);
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else if (e.statusCode === 400) {
            const msg = e.error.message || `${t('failed_to_unassign')}`;
            Swal.fire({ html: `<h4>${msg}`, type: 'error' });
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_unassign')}`, type: 'error' });
          }
        }
      }
    });
  }

  createLocation() {
    const { classes, t } = this.props;
    return (
      <Button
        variant='outlined'
        color='primary'
        onClick={() => this.props.history.push('locations/create')}
        className={classes.button}
        id='createLocationBtn'
      >
        <Icons.Add />
        {t('create_location')}
      </Button>
    );
  }

  titleContent() {
    const { classes, t } = this.props;
    const { search } = this.props.locations.toJS();
    return (
      <div className={classes.titleBar}>
        <Grid className={classes.search}>
          <FormControl variant='outlined' className={classes.formControl} fullWidth>
            <TextField
              variant='outlined'
              size='small'
              value={search || ''}
              name='search'
              id='search'
              className={classes.contentInput}
              placeholder={t('search')}
              onChange={(e) => this.handleChangeSearch(e)}
            ></TextField>
          </FormControl>
        </Grid>
      </div>
    );
  }

  handleChangeSearch = (event) => {
    const { value } = event.target;
    this.props.locations.setData('offset', 0, false);
    this.props.locations.setData('search', value);
  };

  validateTableRow = (data, expectedSize) => {
    return data && Array.isArray(data) && data.length === expectedSize;
  };

  handleChangeRowsPerPage = (value) => {
    this.props.locations.setData('limit', value);
  };

  handlechangePage = (value) => {
    const { limit } = this.props.locations.toJS();
    this.props.locations.setData('offset', value * limit);
  };

  render() {
    const { classes, t } = this.props;
    const { locations, limit, search, sort, order, loading } = this.props.locations.toJS();

    const page = locations.data ? locations.pagination.page - 1 : 0;
    const count = locations.data ? locations.pagination.count : 0;
    const mapValue = (locations.data || []).map((val) => {
      let address = `${val.homeNumber || ''} ${val.road || ''} ${val.subDistrict || ''} ${val.district || ''} ${val.province} ${val.postcode ? val.postcode : ''}`;
      val.groupNo = val.groups.length;
      if (val.id) {
        val.homeNumber = address || '';
      } else {
        val.homeNumber = '';
      }
      return val;
    });
    const ARRAYSIZE = 5;
    const columns = [
      {
        name: 'id',
        label: `${t('id')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'id' && order ? order : 'none',
        },
      },
      {
        name: 'name',
        label: `${t('name')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'name' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[1]}</div>;
          },
        },
      },
      {
        name: 'homeNumber',
        label: `${t('address')}`,
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[2]}</div>;
          },
        },
      },
      {
        name: 'groupNo',
        label: 'Group No.',
        options: {
          filter: true,
          sort: true,
          display: false,
        },
      },
      {
        name: '',
        label: `${t('action')}`,
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return (
              <div className={classes.actionBox}>
                <Link
                  to={`/app/locations/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/view`}
                  title={t('view')}
                  id='viewLocationBtn'
                >
                  <IconButton>
                    <Icons.FormatListBulleted color='primary' />
                  </IconButton>
                </Link>
                <Link
                  to={`/app/locations/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/edit`}
                  title={t('edit')}
                  id='editLocationBtn'
                >
                  <IconButton>
                    {' '}
                    <Icons.Edit color='primary' />
                  </IconButton>
                </Link>
                <IconButton
                  disabled={this.validateTableRow(row, ARRAYSIZE) && row[3] ? false : true}
                  id={`unassign-${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}`}
                  title={t('unassign')}
                  onClick={() => this.unassign(this.validateTableRow(row, ARRAYSIZE) ? row[0] : '')}
                >
                  <Icons.LinkOff color={this.validateTableRow(row, ARRAYSIZE) && row[3] ? 'primary' : 'disabled'} />
                </IconButton>
                <IconButton
                  disabled={this.validateTableRow(row, ARRAYSIZE) && row[3] ? true : false}
                  title={t('delete')}
                  onClick={() => this.deleteItem(this.validateTableRow(row, ARRAYSIZE) ? row[0] : '')}
                >
                  <Icons.Delete color={this.validateTableRow(row, ARRAYSIZE) && row[3] ? 'disabled' : 'primary'} />
                </IconButton>
                {/* <IconButton title="Delete"> <Icons.Delete color="primary" /></IconButton> */}
              </div>
            );
          },
        },
      },
    ];

    return (
      <React.Fragment>
        <Loader loading={loading} />
        <PageTitle title={t('all_locations')} button={this.createLocation()}>
          {this.titleContent()}
        </PageTitle>
        <Grid className={classes.mainContain} container spacing={32}>
          <Grid item xs={12}>
            <MUIDataTable
              data={mapValue}
              columns={columns}
              options={{
                count: locations.data ? locations.pagination.count : 0,
                page: locations.data ? locations.pagination.page - 1 : 0,
                searchText: search,
                serverSide: true,
                pagination: true,
                onTableChange: (action, tableState) => {
                  // console.log(action, tableState);
                  switch (action) {
                    case 'changePage':
                      this.props.locations.setData('offset', tableState.page * tableState.rowsPerPage);
                      // this.props.user.setData('page',tableState.page);
                      break;
                    case 'changeRowsPerPage':
                      this.props.locations.setData('limit', tableState.rowsPerPage);
                      break;
                    case 'search':
                      this.props.locations.setData('offset', 0, false);
                      this.props.locations.setData('search', tableState.searchText);
                      break;
                    case 'sort':
                      const sortList = tableState.announceText.split(' ');
                      this.props.locations.setData('offset', 0, false);
                      this.props.locations.setData('sort', sortList[4], false);
                      this.props.locations.setData('order', sortList[6] === 'descending' ? 'desc' : 'asc');
                      break;
                    default:
                      break;
                  }
                },
                print: false,
                download: false,
                viewColumns: false,
                search: false,
                sortFilterList: true,
                sort: true,
                selectableRows: 'none',
                selectableRowsOnClick: false,
                filter: false,
                filterType: 'dropdown',
                responsive: 'scrollFullHeight',
                rowsPerPageOptions: [10, 15, 50],
                rowsPerPage: limit,
                customFooter: (rowsPerPage, changeRowsPerPage, changePage, textLabels) => {
                  return (
                    <CustomFooter
                      count={count}
                      page={page}
                      rowsPerPage={limit}
                      changeRowsPerPage={this.handleChangeRowsPerPage}
                      changePage={this.handlechangePage}
                      textLabels={textLabels}
                      rowsPerPageOptions={[10, 15, 50]}
                    />
                  );
                },
              }}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  mainContain: {
    marginTop: '5px',
    padding: 16,
  },
  button: {
    height: '38px',
    margin: theme.spacing.unit / 2,
  },
  actionBox: {
    minWidth: '200px',
  },
  columnWidth200: {
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  formControl: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit / 2,
    width: '100%',
    marginLeft: theme.spacing.unit * 2,
  },
  contentInput: {
    '& fieldset': {
      top: '2px',
    },
    '& input': {
      paddingTop: '17px',
      paddingBottom: '9px',
    },
  },
  titleBar: {
    display: 'flex',
    marginTop: '-5px',
  },
  search: {
    width: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '250px',
    },
  },
});

export const page = inject('locations', 'group', 'subGroup', 'user')(observer(LocationsManager));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
